export default __webpack_public_path__ + "static/media/wallet.f7ec8aa5.png";